import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const launchpoolApi = {
  getLaunchpoolList(query) {
    return http.get(API_URLS.LAUNCHPOOL_PUBLIC_POOL, {query});
  },
  getLaunchpoolDetail(query) {
    return http.get(API_URLS.LAUNCHPOOL_PUBLIC_POOL_DETAIL, {query});
  },
  getRebateList(query) {
    return http.get(API_URLS.LAUNCHPOOL_REBATE_CLAIMED_LIST, {query});
  },
  getDistributionList(query) {
    return http.get(API_URLS.LAUNCHPOOL_REBATE_LIST, {query});
  },
  getUserPool(query) {
    return http.get(API_URLS.LAUNCHPOOL_USER_POOL, {query});
  },
  stakeLaunchPool(params) {
    return http.post(API_URLS.LAUNCHPOOL_PURCHASE, {params});
  },
  unStakeLaunchPool(params) {
    return http.post(API_URLS.LAUNCHPOOL_REDEMPTION, {params});
  },
  getLaunchPoolFunds(query) {
    return http.get(API_URLS.LAUNCHPOOL_FUNDS, {query});
  },
  getPoolDesc(query) {
    return http.get(API_URLS.LAUNCHPOOL_POOL_DESC, {query});
  },
  getUnclaimedRebate(query) {
    return http.get(API_URLS.LAUNCHPOOL_MYSELF_UNCLAIMED_REBATE, {query});
  },
  rebateClaimed(params) {
    return http.post(API_URLS.LAUNCHPOOL_REBATE_CLAIM, {params});
  },
  getRebateStat() {
    return http.get(API_URLS.LAUNCHPOOL_REBATE_STAT, {});
  },
  getRebateCountdown(query) {
    return http.post(API_URLS.LAUNCHPOOL_REBATE_COUNTDOWN, {query});
  },
  getUserStakingQuota() {
    return http.get(API_URLS.LAUNCHPOOL_USER_STAKING_QUOTA, {});
  },
};
